export default __webpack_public_path__ + "static/img-app-deployment--mobile-90c1a4c77a8de527403fec263b2f5952.webp";